var _path, _g, _path2, _path3, _path4, _g2, _path5, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgApartments = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 430 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 60",
  d: "M415 512H215a15 15 0 01-15-15V197a15 15 0 0115-15h200a15 15 0 0115 15v300a15 15 0 01-15 15z",
  fill: "#1f84bd"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7",
  fill: "#feb23d"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 61",
  d: "M365 462H265a15 15 0 010-30h100a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 62",
  d: "M365 395.333H265a15 15 0 010-30h100a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 63",
  d: "M365 328.667H265a15 15 0 010-30h100a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 64",
  d: "M365 262H265a15 15 0 010-30h100a15 15 0 010 30z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 65",
  d: "M230 512H15a15 15 0 01-15-15V15A15 15 0 0115 0h200a15 15 0 0115 15z",
  fill: "#6cbbed"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 66",
  d: "M215 0H115v512h115V15a15 15 0 00-15-15z",
  fill: "#6cbbed"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 67",
  d: "M170 512H60V377a15 15 0 0115-15h80a15 15 0 0115 15z",
  fill: "#f9eab6"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8",
  fill: "#ffca36"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 68",
  d: "M90 80H65a15 15 0 010-30h25a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 69",
  d: "M90 145.5H65a15 15 0 010-30h25a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 70",
  d: "M90 211H65a15 15 0 010-30h25a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 71",
  d: "M90 276.5H65a15 15 0 010-30h25a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 72",
  d: "M90 342H65a15 15 0 010-30h25a15 15 0 010 30z"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 73",
  d: "M170 377a15 15 0 00-15-15h-40v150h55z",
  fill: "#f8e49e"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9",
  fill: "#feb23d"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 74",
  d: "M165 80h-25a15 15 0 010-30h25a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 75",
  d: "M165 145.5h-25a15 15 0 010-30h25a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 76",
  d: "M165 211h-25a15 15 0 010-30h25a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 77",
  d: "M165 276.5h-25a15 15 0 010-30h25a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 78",
  d: "M165 342h-25a15 15 0 010-30h25a15 15 0 010 30z"
}))));
export default SvgApartments;